import { jbColors } from 'theme/jbColors';
import { typography } from 'theme/typography';

const MuiTableCell = {
  styleOverrides: {
    root: {
      ...typography.body2,
      padding: '7px',
      fontWeight: 300,
      borderBottom: `1px solid #CCCCCC`,
      maxWidth: 100,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    head: {
      ...typography.body2,
      fontWeight: 300,
      padding: '8px 16px',
      borderBottomColor: jbColors.core.reflexBlue[40],
      color: jbColors.core.reflexBlue[100],
    },
    sizeSmall: {
      padding: '7px',
    },
  },
};

export default MuiTableCell;
